export enum AppConfigKey {
  AmlConfig = 'aml_config',
  BanksMap = 'banks_map',
  BanksMapCountry = 'banks_map_country',
  PaymentTypeMap = 'payment_types_map',
  SupportedBanks = 'supported_banks',
  SupportedPaymentTypes = 'supported_payment_types',
  SupportedCurrencies = 'supported_currencies',
  ReverseBanksMap = 'reverse_banks_map',
  ReverseBanksMapCountry = 'reverse_banks_map_country',
  TradeMethods = 'trade_methods',
  PaymentLinkDomains = 'payment_link_domains',
  PaymentLinkDomainToBankMap = 'payment_link_domain_to_bank_map',
  BankToPaymentTypeMap = 'bank_to_payment_type_map',
  PaymentMethodsByType = 'payment_methods_by_type',
  MonitoringRanges = 'monitoring_ranges',
  Workflow = 'workflow',
  Receipts = 'receipts',
  PayoutOrderWebhookMonitorConfig = 'payout_order_webhook_monitor_config',
  RequisitesVerification = 'requisites_verification',
  ExceptionWords = 'exception_words',
  CurrenciesIdMap = 'currencies_id_map',
  BanksIdMap = 'banks_id_map',
  AvailableP2PProviderTypes = 'available_p2p_provider_types',
  PayinRequisitesGroups = 'payin_requisites_groups',
  ThemeOverrides = 'theme_overrides',
  SidebarHeader = 'sidebar_header',
  OrderStatusReasons = 'payin_order_status_reason',
  DisputeCompletedStatusReasons = 'payin_dispute_completed_status_reason',
  EndpointIdMap = 'endpoint_id_map',
  OtherBankCodeByCurrency = 'other_bank_code_currency_map',
  InternalPaymentTypes = 'internal_payment_types',
  TelegramOrdersBotUsersWhitelist = 'telegram_ordes_bot_users_whitelist',
  TelegramOrdersBotConfig = 'telegram_orders_bot_config',
  AdditionalP2POrderFields = 'additional_p2p_order_fields',
  PayinOrderP2POverrides = 'payin_order_p2p_overrides',
  PayinRequisitesP2POverrides = 'payin_requisites_p2p_overrides',
  AccountNumberQrSupportedCombinations = 'account_number_qr_supported_combinations',
  MultitransferMap = 'multitransfer_map',
  MultitransferConfig = 'multitransfer_config',
  MissedMappingConfig = 'missed_mapping_config',
  ResolveCaptchaConfigs = 'resolve_captcha_configs',
  PaymentMethodNamesMap = 'payment_method_names_map',
  InternalTransferCategories = 'internal_transfer_categories',
  WithdrawalFee = 'withdrawal_fee',
  DepositFee = 'deposit_fee',
  BankAliases = 'bank_aliases',
  ShopIntegrationTypes = 'shop_integration_types',
  RequisiteFieldMapping = 'requisite_field_mapping',
  BankCodeFields = 'bank_code_fields',
  SberQrBankBic = 'sber_qr_bank_bic',
  BankPaymentTypeServiceMap = 'bank_payment_type_service_map',
  QrManagerConfig = 'qr_manager_config',
  DefaultMaxParallelCustomerOrders = 'default_max_parallel_customer_orders',
  ProviderPaymentLinkFieldPath = 'provider_payment_link_field_path',
  BankRequiredPaymentMethods = 'bank_required_payment_methods',
  WholeAmountCurrencies = 'whole_amount_currencies',
  ReceiverTypesMap = 'receiver_types_map',
}
